
import { Lightbulb } from "lucide-react";

export const ExpenseButtons = ({step, showGuide, openInsightModal, cumulative}) => {

    return <div className={"ml-auto space-x-1 li-buttons" }>
        {openInsightModal && step.status !== 'complete' && <button
            onClick={(e) => {
                e.stopPropagation()

                openInsightModal(step)
            }}
            type="button"
            className="inline-flex items-center justify-center rounded bg-indigo-200 px-3 py-2 text-sm font-medium text-indigo-700 shadow-sm ring-1 ring-inset ring-indigo-300 hover:bg-indigo-300 w-12 h-12"
        >
            <Lightbulb className="h-5 w-5" />
        </button>}
    </div>
}
